'use strict';

/* globals define, config, $, ajaxify */

var RELATIVE_PATH_TRIMMED = config.relative_path.replace(/^\/|\/$/g, '');

define(RELATIVE_PATH_TRIMMED + '/lesson/lesson-analytics', [
	config.relative_path + '/plugins/nodebb-plugin-lessons/static/vendor/chartjs/Chart.min.js',
	'translator',
], function (Chart, translator) {
	var	LessonAnalytics = {};

	LessonAnalytics.init = function () {
		formatDates();
		createChart();
	};

	function formatDates() {
		$('.formatted-date').each(function () {
			var date = parseInt($(this).html(), 10);

			if (isNaN(date)) { return; }

			$(this).html(new Date(date).toLocaleString());
		});
	}

	function createChart() {
		translator.translate('[[lessons:finished-attempts]]  ||  [[lessons:not-finished-attempts]]', function (text) {
			text = text.split('  ||  ');

			new Chart($('#finishedLesson'), {
				type: 'pie',
				data: {
					labels: [text[0], text[1]],
					datasets: [{
						backgroundColor: [
							'#2ecc71',
							'#e74c3c',
						],
						data: [ajaxify.data.analytics.finishedLessonCount, ajaxify.data.analytics.notFinishedLessonCount],
					}],
				},
			});
		});
	}

	return LessonAnalytics;
});
